// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"d43f8ee6","498":"dc805d20","703":"eac744ec"}[chunkId] + ".chunk.js";
};